<div class="message-header" *ngIf="title">
    <p>{{title}}</p>
    <button type="button" class="delete" aria-label="delete" (click)="remove.emit()"></button>
</div>
<div class="message-body">
    {{message}}
    <ng-content></ng-content>
</div>
